export default [
  {path: 'sysmenus', name: 'sysmenus', component: () => import('../pages/admin/menu/SysMenus.vue')},
  {path: 'sysapplys', name: 'sysapplys', component: () => import('../pages/admin/menu/SysApplys.vue')},
  {path: 'sysroles', name: 'sysroles', component: () => import('../pages/admin/role/SysRoles.vue')},
  {path: 'sysusers', name: 'sysusers', component: () => import('../pages/admin/user/SysUsers.vue')},
  {path: 'sysconfig', name: 'sysconfig', component: () => import('../pages/admin/configure/SysConfig.vue')},
]
